<template>
    <div :class="['hk-footer', theme]">
        <div class="hk-footer-container">
            <p class="copyright flex flex-center">
                <span>重庆市巴蜀中学校</span>
                <span>办公室电话：023-63002371</span>
                <span>招生咨询电话：023-63002629</span>
                <span>学校地址：重庆市渝中区北区路51号</span>
                <span>邮编：400013</span>
            </p>
            <p class="copyright flex flex-center">版权所有<span>巴蜀中学</span></p>
            <p class="records flex flex-center">
                <a target="_blank" href="http://beian.miit.gov.cn/">渝ICP备11004221号-3</a>
                <a
                    class="records-tag"
                    target="_blank"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010302001958"
                    >渝公网安备 50010302001958号</a
                >
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HkFooter',
    props: {
        theme: {
            type: String,
            default: 'light',
            validator: (val) => {
                return ['light', 'dark'].includes(val);
            }
        }
    },
    data() {
        return {};
    },
    created() {},
    mounted() {}
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.hk-footer {
    box-sizing: border-box;
    width: 100%;
    height: 170px;
    padding: 32px 0;
    &-container {
        width: 1200px;
        margin: 0 auto;
        .copyright {
            font-size: 12px;
            font-family: '宋体';
            font-weight: 500;
            color: #b3b6b9;
            line-height: 30px;
            text-align: center;
            span {
                margin-left: 20px;
            }
        }
        .records {
            a {
                font-size: 12px;
                font-family: '宋体';
                font-weight: 500;
                color: #b3b6b9;
                line-height: 30px;
                text-decoration: none;
                margin-left: 20px;
            }
            &-tag {
                padding-left: 25px;
                background: url('~@images/base/police.png') no-repeat left center;
            }
        }
    }
}
.dark {
    background-color: #292629;
}
</style>
